import { makeStyles, mergeClasses } from '@griffel/react';
import { tokens, typographyStyles } from '@fluentui/react-theme';
import { HighContrastSelector } from '../../utilities/index';
/**
 * @internal
 */ export const sparklineClassNames = {
    inlineBlock: 'fui-sprk__inlineBlock',
    valueText: 'fui-sprk__valueText'
};
/**
 * Base Styles
 */ const useStyles = makeStyles({
    inlineBlock: {
        display: 'inline'
    },
    valueText: {
        ...typographyStyles.caption1,
        fill: tokens.colorNeutralForeground1,
        [HighContrastSelector]: {
            opacity: 0.1,
            stroke: 'rgb(179, 179, 179)',
            forcedColorAdjust: 'none'
        }
    }
});
/**
 * Apply styling to the Carousel slots based on the state
 */ export const useSparklineStyles_unstable = (props)=>{
    var _props_styles, _props_styles1;
    const baseStyles = useStyles();
    return {
        inlineBlock: mergeClasses(sparklineClassNames.inlineBlock, baseStyles.inlineBlock, (_props_styles = props.styles) === null || _props_styles === void 0 ? void 0 : _props_styles.inlineBlock),
        valueText: mergeClasses(sparklineClassNames.valueText, baseStyles.valueText, (_props_styles1 = props.styles) === null || _props_styles1 === void 0 ? void 0 : _props_styles1.valueText)
    };
};
